import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

import type { Book, BudgetRule, BudgetRuleKind } from "@/schemas";

import type { GroupedCategory } from "../types";

import { RuleGroupsPanel } from "./rule-groups-panel";

export function BudgetItemsCard({
  incomeGroups,
  investmentGroups,
  expenseGroups,
  currencyCode,
  fiatById,
  booksById,
  onOpenCreate,
  onEditRule,
  onDeleteRule,
}: {
  incomeGroups: GroupedCategory[];
  investmentGroups: GroupedCategory[];
  expenseGroups: GroupedCategory[];
  currencyCode: string;
  fiatById: Map<string, string>;
  booksById: Map<string, Book>;
  onOpenCreate: (kind: BudgetRuleKind, category?: string) => void;
  onEditRule: (rule: BudgetRule) => void;
  onDeleteRule: (ruleId: string) => void;
}) {
  return (
    <Card className="h-full">
      <CardHeader className="flex flex-row items-center justify-between pb-6">
        <div className="space-y-1">
          <CardTitle>Budget Items</CardTitle>
          <CardDescription>
            Manage your planned income, investments, and expenses.
          </CardDescription>
        </div>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="income" className="w-full">
          <TabsList variant="line" className="mb-6">
            <TabsTrigger value="income">Income</TabsTrigger>
            <TabsTrigger value="investment">Investments</TabsTrigger>
            <TabsTrigger value="expense">Expenses</TabsTrigger>
          </TabsList>

          <TabsContent value="income">
            <RuleGroupsPanel
              kind="income"
              groups={incomeGroups}
              currencyCode={currencyCode}
              fiatById={fiatById}
              booksById={booksById}
              onCreate={() => onOpenCreate("income")}
              onCreateInCategory={(category) =>
                onOpenCreate("income", category)
              }
              onEdit={onEditRule}
              onDelete={onDeleteRule}
            />
          </TabsContent>

          <TabsContent value="investment">
            <RuleGroupsPanel
              kind="investment"
              groups={investmentGroups}
              currencyCode={currencyCode}
              fiatById={fiatById}
              booksById={booksById}
              onCreate={() => onOpenCreate("investment")}
              onCreateInCategory={(category) =>
                onOpenCreate("investment", category)
              }
              onEdit={onEditRule}
              onDelete={onDeleteRule}
            />
          </TabsContent>

          <TabsContent value="expense">
            <RuleGroupsPanel
              kind="expense"
              groups={expenseGroups}
              currencyCode={currencyCode}
              fiatById={fiatById}
              booksById={booksById}
              onCreate={() => onOpenCreate("expense")}
              onCreateInCategory={(category) =>
                onOpenCreate("expense", category)
              }
              onEdit={onEditRule}
              onDelete={onDeleteRule}
            />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
}
